<template>
  <div>
    <div id="profilecard" class="flexwrap centercenter" v-if="!authenticated">
      <h2 style="padding: 5vw">Connecte-toi pour accéder au tableau de bord !</h2>
    </div>
    <div id="profilecard" v-else>
      <!--
      <div class="onglets" v-if="!isMobile">
        <div class="onglet clickable plainStandardTheme flexwrap centercenter"
             :class="{'selected': currentPage === page.profile}" @click="changePage(page.profile)">
          <h2>Mon profil</h2>
        </div>
        <div class="onglet clickable plainStandardTheme flexwrap centercenter"
             :class="{'selected': currentPage === page.premium}" @click="changePage(page.premium)">
          <h2 v-if="profile.datas.is_premium">Mon abonnement</h2>
          <h2 v-else>Passer Premium</h2>
        </div>
      </div> -->
      <div v-if="profile.datas.trial_days_left > 0 && !profile.datas.is_premium && isMobile"
           class="trial premium flexwrap">
        <span>Il te reste {{ profile.datas.trial_days_left }} jours d'essai gratuit&nbsp;</span> <span>des fonctionnalités Premium&nbsp;</span>
        <i class="fas fa-burn" style="font-size: 0.9em; margin-left: 0.3vw; margin-right: 0.3vw"></i>&nbsp;!
      </div>
      <div v-else></div>

      <div id="innerPage">
        <transition  :name="!isMobile?'slide-fade':'slide-fade-left'" mode="out-in" appear>
          <router-view :key="dataLoaded.user" v-if="dataLoaded.user">
          </router-view>
        </transition>

        <!--<component :is="currentPage" :key="dataLoaded.user"  v-if="dataLoaded.user"></component>-->
      </div>
    </div>
  </div>

  <!--
  <closable-card :title="'Tableau de bord'" :padding="'0'">

    <!- -
      <div id="profilecard" class="flexwrap centercenter" v-else>
        <h2 style="padding: 5vw">Le tableau de bord est disponible uniquement sur la version PC de l'application.</h2>
        <div class="paddingRound marginRound flexwrap centercenter clickable mediumShadow mediumRoundAngles"
             style="font-size:1.2em; margin-bottom: 1vw; justify-self: center; background-color: #596C3D; color:#eee2c7;"
             @click="logout">Se déconnecter</div>
      </div>
      - ->


  </closable-card>-->
</template>

<script>
import {mapGetters} from 'vuex'
import {lock} from "@/main";

export default {
  components: {
    closableCard: () => import(/* webpackPrefetch: true */ '@/components/closableCard.vue'),
  },

  name: "dashboard",

  created() {
    this.currentPage = this.$route.name
  },

  methods: {
    changePage: function (newOnglet) {
      this.currentPage = newOnglet;
      this.$router.push({name: this.currentPage})
    },
    logout() {
      this.$webAuth.logout({
        returnTo: window.location.origin
      });

    }
  },

  watch: {
    '$route': function () {
      this.currentPage = this.$route.name
    }
  },


  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
      'dataLoaded',
      'windowwidth',
      'authenticated'
    ]),
    trialRemainingTime: function () {
      let subDate = Date.parse(this.profile.datas.subscribed)
      let subSinceInMs = Date.now() - subDate
      let remainingMilliseconds = this.trialDuration - subSinceInMs
      let remainingDays = remainingMilliseconds / (1000 * 3600 * 24)
      return Math.round(remainingDays)
    }
  },

  data() {
    return {
      page: {
        profile: 'profile',
        premium: 'premium'
      },
      currentPage: 'profile',
      trialDuration: 14 * 24 * 3600 * 1000
    }
  }
}
</script>

<style>

#profilecard {
  padding: 0;
  max-height: 100%;
  height: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  /*grid-template-rows: auto auto 1fr;*/
}

.onglets {
  padding: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr;
}

.onglet {
  height: fit-content;
  padding: 0.5vw;
  z-index: 1;
}

.onglet:hover {
  background: hsl(330, 5%, 25%);
}

.onglet h2 {
  color: whitesmoke;
}

.selected {
  background: hsl(330, 5%, 25%);
  z-index: 0;
}

#innerPage {
  /*padding: 1vw;*/
  /*width: 90%;*/

  color: #162327;
  overflow: hidden;
  display: flex;
  justify-content: center;
  justify-self: center;

  height: calc(100% - 6vw);
  width: calc(100% - 6vw);
  padding: 3vw;
}

.trial {
  padding: 0.5vw;
  text-align: center;
  align-items: center;
  align-content: center;
  display: flex;
  justify-content: center;
}

@media screen and (max-device-width: 767px) {

  .trial {
    padding: 2vw;
  }

  .onglets {
    height: inherit;
  }

  .onglet {
    height: inherit;
    padding: 0.5vw;
    z-index: 1;
    text-align: center;
  }


  .onglet h2 {
    font-size: 1.2em;
  }
  #innerPage {
    height: 100%;
    width: 100%;
    padding: 0;
  }
}
</style>